import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { ErrorPage } from '../../pages/error/ErrorPage';
import { isChunkLoadError } from '../../monitoring/privacy';
import { captureAppError } from '../../monitoring/sentry';

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  useEffect(() => {
    if (!isRouteErrorResponse(error) && !isChunkLoadError(error)) captureAppError(error);
  }, [error]);
  // Marker checked by the build (scripts/prerender-guards.mjs): a page that rendered the error fallback is never shipped.
  return <div data-route-error="true"><ErrorPage /></div>;
};
